import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, hasClass, findIn, trigger, findAllIn, closest, on} from '@elements/dom-utils';

export function init () {

    onFind('.js-ticket-checkbox', baseElement => {
        let checkbox = findIn('.js-ticket-checkbox__check', baseElement);
        let ticketCheckboxIcon = findIn('.js-ticket-checkbox__icon', baseElement);
        let ticketCheckboxLabel = findIn('.js-ticket-checkbox__label', baseElement);

        const updateState = () => {
            if(checkbox.checked) {
                addClass('is-active', baseElement);
                addClass('is-active', ticketCheckboxIcon);
                baseElement.setAttribute('aria-checked', 'true');
            } else {
                removeClass('is-active', baseElement);
                removeClass('is-active', ticketCheckboxIcon);
                baseElement.setAttribute('aria-checked', 'false');
            }
        };

        on('change', (e) => {
            updateState();
        }, checkbox);

        on('click', (e) => {
            if(e.target !== checkbox && e.target !== ticketCheckboxLabel){
                checkbox.checked = !checkbox.checked;
                trigger('change', checkbox);
            }
        }, baseElement);

        on('keydown', (e) => {
            if(e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
                e.preventDefault();
                checkbox.checked = !checkbox.checked;
                trigger('change', checkbox);
            }
        }, baseElement);

        on('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                checkbox.checked = !checkbox.checked;
                trigger('change', checkbox);
            }
        }, checkbox);

    });

    onFind('.js-ticket-checkboxes-season', baseElement => {
        let resetButton = findIn('.js-ticket-checkboxes-season__reset', baseElement);
        let radios = findAllIn('.js-ticket-checkbox__check', baseElement);

        if (!resetButton) {
            return;
        }

        on('click', () => {
            radios.forEach(radio => {
                if (radio.checked) {
                    radio.checked = false;
                    trigger('change', radio);
                }
            });
        }, resetButton);
    });
}